import { OrderStatus, Option, OrderType } from "../types";

export const OrderStatusLabels: Record<OrderStatus, string> = {
  [OrderStatus.WAITING_FOR_PAYMENT]: "En attente de paiement",
  [OrderStatus.PROCESSING]: "En traitement",
  [OrderStatus.COOKING]: "En cours de préparation",
  [OrderStatus.WAITING_FOR_RIDER]: "En attente du livreur",
  [OrderStatus.WAITING_FOR_PICKUP]: "Prêt pour retrait",
  [OrderStatus.DRIVER_ASSIGNED]: "Livreur assigné",
  [OrderStatus.COLLECTED]: "Collecté",
  [OrderStatus.COMPLETED]: "Terminé",
  [OrderStatus.CANCELLED]: "Annulé",
};

export const orderStatusColors: Record<OrderStatus, string> = {
  [OrderStatus.WAITING_FOR_PAYMENT]: "bg-rose-400",
  [OrderStatus.PROCESSING]: "bg-yellow-400",
  [OrderStatus.COOKING]: "bg-orange-400",
  [OrderStatus.WAITING_FOR_RIDER]: "bg-blue-400",
  [OrderStatus.WAITING_FOR_PICKUP]: "bg-indigo-400",
  [OrderStatus.DRIVER_ASSIGNED]: "bg-indigo-600",
  [OrderStatus.COLLECTED]: "bg-green-400",
  [OrderStatus.COMPLETED]: "bg-green-800",
  [OrderStatus.CANCELLED]: "bg-red-500",
};

export const orderStatusOptions: Option[] = [
  { label: "Tous", value: "" },
  ...Object.entries(OrderStatusLabels).map(([value, label]) => ({
    label,
    value,
  })),
];

export const orderTypeOptions: Option[] = [
  { label: "Livraison", value: OrderType.DELIVERY },
  { label: "À emporter", value: OrderType.PICKUP },
];

export const OrderTypeLabels: Record<OrderType, string> = {
  [OrderType.PICKUP]: "À emporter",
  [OrderType.DELIVERY]: "Livraison",
};

export const payoutOptions: Option[] = [
  { label: "HT", value: "ht" },
  { label: "TTC", value: "ttc" },
];

export const HIDDEN_PASSWORd = "********";
